import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Loader from './Loader';

// 菜单权限路由守卫: 普通用户需超管开通对应板块权限才能访问
// 用法: <Route element={<PermRoute perm="licenses" />}> ... </Route>
// orVip: VIP贴牌入口(如系统设置页)对VIP放行, 无论是否勾选该perm, 页面内再按角色分流
const PermRoute = ({ perm, orVip = false }) => {
  const { currentUser, loading, isVip } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f6f8fa]">
        <Loader />
      </div>
    );
  }

  // admin 角色拥有全部权限
  const perms = currentUser?.role === 'admin'
    ? ['dashboard', 'statistics', 'monitor', 'commands', 'signals', 'licenses', 'system']
    : (Array.isArray(currentUser?.menuPermissions) ? currentUser.menuPermissions : []);

  // VIP贴牌豁免: 先于perm判断(系统设置页VIP无system权限也要能进)
  if (orVip && isVip) {
    return <Outlet />;
  }

  if (!perms.includes(perm)) {
    // 未登录(理论上 ProtectedRoute 已拦)或无权限 -> 回个人资料页
    if (!currentUser) {
      return <Navigate to="/login" replace state={{ from: location }} />;
    }
    return <Navigate to="/profile" replace />;
  }

  return <Outlet />;
};

export default PermRoute;
